import QRCode from "qrcode";
import { specsUrl } from "@/lib/publicUrl";

// 200mm x 200mm at 300 DPI => print-ready square PNG for large-format sample boards.
const DPI = 300;
const SIZE = Math.round((200 / 25.4) * DPI); // 2362px

function slug(s) {
  return (s || "product")
    .toString()
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/(^-|-$)/g, "")
    .slice(0, 60);
}

function wrapText(ctx, text, x, y, maxWidth, lineHeight, maxLines) {
  const words = (text || "").split(" ");
  const lines = [];
  let line = "";
  for (const w of words) {
    const test = line ? `${line} ${w}` : w;
    if (ctx.measureText(test).width > maxWidth && line) {
      lines.push(line);
      line = w;
    } else {
      line = test;
    }
  }
  if (line) lines.push(line);
  const shown = lines.slice(0, maxLines);
  if (lines.length > maxLines) shown[maxLines - 1] += "…";
  shown.forEach((ln, i) => ctx.fillText(ln, x, y + i * lineHeight));
  return shown.length;
}

/**
 * Generate and download a minimalist 200mm x 200mm QR sign PNG that links to a
 * product's public technical-specs page. High resolution (2362px @ 300 DPI).
 */
export async function generateQrSign({ productId, productName }) {
  const url = specsUrl(productId);

  const qrPx = 1200;
  const qrCanvas = document.createElement("canvas");
  await QRCode.toCanvas(qrCanvas, url, {
    width: qrPx,
    margin: 1,
    errorCorrectionLevel: "H",
    color: { dark: "#0A0A0A", light: "#FFFFFF" },
  });

  const c = document.createElement("canvas");
  c.width = SIZE;
  c.height = SIZE;
  const ctx = c.getContext("2d");

  ctx.fillStyle = "#FFFFFF";
  ctx.fillRect(0, 0, SIZE, SIZE);

  const pad = Math.round(SIZE * 0.05);
  ctx.strokeStyle = "#111111";
  ctx.lineWidth = Math.round(SIZE * 0.005);
  ctx.strokeRect(pad, pad, SIZE - pad * 2, SIZE - pad * 2);

  ctx.textAlign = "center";

  ctx.fillStyle = "#0A0A0A";
  ctx.font = `800 ${Math.round(SIZE * 0.058)}px Arial, "Helvetica Neue", sans-serif`;
  ctx.fillText("STON LINK", SIZE / 2, Math.round(SIZE * 0.15));

  ctx.fillStyle = "#FF5A1F";
  ctx.font = `700 ${Math.round(SIZE * 0.021)}px Arial, sans-serif`;
  ctx.fillText("B U I L D I N G   M A T E R I A L S", SIZE / 2, Math.round(SIZE * 0.185));

  ctx.fillStyle = "#18181B";
  ctx.font = `700 ${Math.round(SIZE * 0.04)}px Arial, sans-serif`;
  wrapText(
    ctx,
    (productName || "Product").toUpperCase(),
    SIZE / 2,
    Math.round(SIZE * 0.26),
    SIZE - pad * 2 - 80,
    Math.round(SIZE * 0.048),
    2
  );

  ctx.fillStyle = "#52525B";
  ctx.font = `500 ${Math.round(SIZE * 0.025)}px Arial, sans-serif`;
  ctx.fillText("Scan for full technical specifications", SIZE / 2, Math.round(SIZE * 0.36));

  const qx = Math.round((SIZE - qrPx) / 2);
  const qy = Math.round(SIZE * 0.4);
  ctx.drawImage(qrCanvas, qx, qy, qrPx, qrPx);

  ctx.fillStyle = "#A1A1AA";
  ctx.font = `500 ${Math.round(SIZE * 0.02)}px Arial, sans-serif`;
  ctx.fillText("stonlink.com", SIZE / 2, qy + qrPx + Math.round(SIZE * 0.05));

  const dataUrl = c.toDataURL("image/png");
  const a = document.createElement("a");
  a.href = dataUrl;
  a.download = `${slug(productName)}-qr-sign-200mm.png`;
  document.body.appendChild(a);
  a.click();
  a.remove();
}
